import React from 'react'
import CategoryForm from '../CategoryForm'
import { useSelector } from 'react-redux'
import questionSelectors from '../../../../../../store/selectors/question.selectors'
import { useFetchQuestionsQuery, useUpdateCategoryMutation } from '../../../../../../store/apis/question.api'
import { fetchQuestionsSelectors } from '../../../../../../store/apis/utils/selectors/question.api.selectors'
import { useParams } from 'react-router'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'
import { useVersionId } from '../../../../../../utils/parseURL.helper'
import DeleteCategoryButton from './DeleteCategoryButton'

const EditCategoryForm = ({ onSuccess }) => {
    const editingCategoryId = useSelector(questionSelectors.editingCategoryId)
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)

    const { token } = useParams()
    const versionId = useVersionId()
    const { data: category } = useFetchQuestionsQuery(
        { token, versionId },
        {
            selectFromResult: result => fetchQuestionsSelectors.category({ categoryId: editingCategoryId }, result),
        },
    )
    const [updateCategory, updateCategoryResult] = useUpdateCategoryMutation()

    const onSubmit = async values => {
        const response = await updateCategory({
            ...category,
            ...values,
            token,
            versionId,
            questionId: editingQuestionId,
            conceptualLabels: values.conceptualLabels,
        })
        if ('data' in response) {
            openNotificationWithIcon('success', 'Category updated successfully')
            onSuccess()
        }
    }

    const initialValues = {
        name: category?.name,
        feedback: category?.feedback,
        description: category?.description,
        colorId: category?.colorId ?? category?.id,
        grade: category?.grade,
        conceptualLabels: category?.conceptualLabels,
    }

    return (
        <CategoryForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            error={updateCategoryResult?.error}
            loading={updateCategoryResult?.isLoading}
            actionName='Save'
            extraActions={[<DeleteCategoryButton 
                key={editingCategoryId}
                categoryId={editingCategoryId} 
                questionId={editingQuestionId} 
                onSuccess={onSuccess}
            />]}
        />
    )
}

export default EditCategoryForm
